import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var path = process.env.VUE_APP_BASE_API;
import { mapGetters } from 'vuex';
import infoList from '@/mixins/infoList';
import { getFileList, deleteFile as _deleteFile } from '@/api/fileUploadAndDownload';
import { formatTimeToStr } from '@/utils/date';
import CustomPic from '@/components/customPic';
import UploadImage from '@/components/upload/image';
import { saveAs } from 'file-saver';

var _this;

export default {
  name: 'Upload',
  components: {
    CustomPic: CustomPic,
    UploadImage: UploadImage
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time !== null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      fullscreenLoading: false,
      listApi: getFileList,
      path: path,
      tableData: [],
      formData: {}
    };
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  created: function created() {
    this.formData = this.initData();
    this.getTableData();

    if (_this.$route.params) {
      _this.formData.tag = _this.$route.params.tag || '';
    }
  },
  methods: {
    initData: function initData() {
      return {
        tag: '',
        isPress: true,
        fileSize: 300,
        marks: {
          300: '300KB',
          1024: '1M',
          2048: '2M'
        }
      };
    },
    deleteFile: function deleteFile(row) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$confirm('此操作将永久文件, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  var res;
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _deleteFile(row);

                        case 2:
                          res = _context.sent;

                          if (res.code === 0) {
                            _this2.$message({
                              type: 'success',
                              message: '删除成功!'
                            });

                            if (_this2.tableData.length === 1 && _this2.page > 1) {
                              _this2.page--;
                            }

                            _this2.getTableData();
                          }

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }))).catch(function () {
                  _this2.$message({
                    type: 'info',
                    message: '已取消删除'
                  });
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onUploadSuccess: function onUploadSuccess(res) {
      this.getTableData();
    },
    downloadFile: function downloadFile(row) {
      saveAs(row.url);
    },
    onView: function onView(row) {
      window.open(row.url);
    },
    onPressSizeChange: function onPressSizeChange() {
      this.$refs.uploadImage.onPressSizeChange();
    }
  }
};